import type { Persona } from "./persona"

export const ACTIVITY_FEED_TABLE_VIEW_COOKIE_NAME = "activityFeedTableView"
export const COLLECTION_ACTIVITY_FEED_TABLE_VIEW_COOKIE_NAME =
  "collectionActivityFeedTableView"
export const PROFILE_ACTIVITY_FEED_TABLE_VIEW_COOKIE_NAME =
  "profileActivityFeedTableView"
export const ACTIVITY_FEED_TABLE_VIEW = {
  table: "table",
  tableCompact: "tableCompact",
} as const

export type ActivityFeedTableView = keyof typeof ACTIVITY_FEED_TABLE_VIEW

export const getDefaultActivityFeedTableView = (persona: Persona) => {
  return persona === "collector"
    ? ACTIVITY_FEED_TABLE_VIEW.table
    : ACTIVITY_FEED_TABLE_VIEW.tableCompact
}

export function parseActivityFeedTableView(
  activityFeedTableView: string | undefined,
  persona: Persona,
): ActivityFeedTableView {
  if (
    activityFeedTableView &&
    activityFeedTableView in ACTIVITY_FEED_TABLE_VIEW
  ) {
    return activityFeedTableView as ActivityFeedTableView
  }

  return getDefaultActivityFeedTableView(persona)
}

const activityFeedTableViews = Object.values(ACTIVITY_FEED_TABLE_VIEW)

export function getActivityFeedTableViewStaticParams() {
  return activityFeedTableViews.map(activityFeedTableView => ({
    tableView: activityFeedTableView,
  }))
}
